export default __webpack_public_path__ + "static/media/icon.d2853586.svg";